import { render, staticRenderFns } from "./change-mobile.vue?vue&type=template&id=00608167&"
import script from "./change-mobile.vue?vue&type=script&lang=js&"
export * from "./change-mobile.vue?vue&type=script&lang=js&"
import style0 from "./change-mobile.vue?vue&type=style&index=0&id=00608167&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports